import FEED_KEYWORDS from 'core/keywords';

export const INVENTORY_VALIDATION_DATASOURCE_QUERY_KEY =
	'datasource-access/inventory-validation';

const LOCATION_STATE_KEY = 'pricingSignalsInventoryValidation';

function normalizeOrderIds(orderIds) {
	return Array.isArray(orderIds)
		? orderIds
				.map(orderId => Number(orderId))
				.filter(orderId => Number.isInteger(orderId) && orderId > 0)
		: [];
}

export function buildPricingSignalsInventoryValidationNavigationState(
	orderIds,
) {
	const normalizedOrderIds = normalizeOrderIds(orderIds);
	if (normalizedOrderIds.length === 0) return undefined;

	return {
		[LOCATION_STATE_KEY]: {
			datasourceQueryKey: INVENTORY_VALIDATION_DATASOURCE_QUERY_KEY,
			orderIds: normalizedOrderIds,
		},
	};
}

export function navigateToInventoryValidationOrders({ history, orderIds }) {
	const state = buildPricingSignalsInventoryValidationNavigationState(orderIds);
	if (!state) return;

	history.push(`${FEED_KEYWORDS.ROUTES.FEED.PATH}/orders`, state);
}

export function getPricingSignalsInventoryValidationNavigationIntent(location) {
	const intent = location?.state?.[LOCATION_STATE_KEY];
	if (!intent) return null;

	const orderIds = normalizeOrderIds(intent.orderIds);
	if (
		intent.datasourceQueryKey !== INVENTORY_VALIDATION_DATASOURCE_QUERY_KEY ||
		orderIds.length === 0
	) {
		return null;
	}

	return {
		datasourceQueryKey: intent.datasourceQueryKey,
		orderIds,
	};
}

export function clearPricingSignalsInventoryValidationNavigationIntent(
	history,
	location,
) {
	if (!location?.state?.[LOCATION_STATE_KEY]) return;

	const nextState = { ...location.state };
	delete nextState[LOCATION_STATE_KEY];

	history.replace({
		pathname: location.pathname,
		search: location.search,
		hash: location.hash,
		state: Object.keys(nextState).length > 0 ? nextState : undefined,
	});
}
